export default __webpack_public_path__ + "static/media/product-4.f0604f31.jpg";